// extracted by mini-css-extract-plugin
export default {"container":"NoteInput_container__sEws0"};